'use client';

import dynamic from 'next/dynamic';
import { type ComponentType } from 'react';
import { useStepsContext, type ComponentName } from '@/providers/pi-multi-step-form/StepsContext';

const WhatHappened = dynamic(() => import('./what-happened'));
const WereYouInjured = dynamic(() => import('./were-you-injured'));
const TellUsAboutYourself = dynamic(() => import('./tell-us-about-yourself'));
const HeresWhatsNext = dynamic(() => import('./heres-whats-next'));

const components: Record<ComponentName, ComponentType> = {
  WhatHappened,
  WereYouInjured,
  TellUsAboutYourself,
  HeresWhatsNext,
};

export default function Wrapper() {
  const { step } = useStepsContext();

  const CurrentStep = components[step.component];

  return <CurrentStep />;
}
